import { FC } from 'react';
import { useGetIsDarkMode, useGetShowingLoadingModal } from 'src/custom-hooks';

type propsType = {
    cancelHandler: () => void;
    isDisabledSaveButton: boolean;
    saveHandler: () => void;
};

export const FloatingSaveBar: FC<propsType> = ({ cancelHandler, isDisabledSaveButton, saveHandler }) => {
    const isDarkMode = useGetIsDarkMode();
    const showingLoadingModal = useGetShowingLoadingModal();

    return (
        <div className={`d-flex justify-content-center ${isDarkMode ? 'bg-dark' : 'bg-secondary'} border-top gap-2 p-3`}
            style={{
                position: 'fixed',
                bottom: 0,
                left: 0,
                width: '100%',
                zIndex: 100
            }}
        >
            <button className={'btn btn-general-blue border'}
                style={{ width: '150px' }}
                onClick={saveHandler}
                disabled={showingLoadingModal || isDisabledSaveButton}
            >
                Guardar
            </button>
            <button className={'btn btn-general-red border'}
                style={{ width: '150px' }}
                onClick={cancelHandler}
                disabled={showingLoadingModal}
            >
                Cancelar
            </button>
        </div>
    );
}
